import React from "react";
import { Link } from "react-router-dom";
import "./styles.scss";
import Logo from "components/atoms/logo/index.jsx";
import CompanyInfo from "components/atoms/companyInfo/index.jsx";

export default class Footer extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const sealsFooter = this.props.seals;
    return (
      <div className="footer">
        <div className="container">
          <div className="logo">
            <Link to="/">
              <Logo />
            </Link>
          </div>

          <div className="companyInfo">
            <CompanyInfo seals={sealsFooter} />
          </div>
        </div>
      </div>
    );
  }
}
